import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { embeddedCard } from '../layout';

/** A white form section; its legend is the section heading. Plain `<label>`s inside stack the caption above
 * the control, antd's own label wrappers (radios, checkboxes) keep their layout. */
export const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  margin: 0;
  border: none;
  border-radius: 8px;
  padding: 16px 20px 20px;
  background: ${p => p.theme.color.Neutral0};
  ${embeddedCard}

  legend {
    float: left;
    width: 100%;
    margin: 0 0 4px;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${p => p.theme.color.Neutral100};
  }

  label:not([class*='ant-']) {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: ${p => p.theme.color.Neutral80};
  }
`;

/** A group inside a section: no panel of its own, caption styled like a field label, flush left. */
export const SubFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: none;

  legend {
    float: left;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    color: ${p => p.theme.color.Neutral80};
  }
`;

export const DefaultRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${p => p.theme.color.Neutral80};
`;

export const Muted = styled.span`
  color: ${p => p.theme.color.Neutral60};
  font-size: 12px;
`;

export const CtaRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 12px;
`;

export const FieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BackLink = styled(Link)`
  align-self: flex-start;
  color: ${p => p.theme.color.Blue100};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const IdNumber = styled.span`
  font-weight: 400;
  color: ${p => p.theme.color.Neutral60};
`;

export const Heading = styled.h1`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${p => p.theme.color.Neutral100};
`;

/** A control with its «?» hint beside it, not inside its label. */
export const HintRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;
